import { render, staticRenderFns } from "./Police.vue?vue&type=template&id=8007aa6c&"
import script from "./Police.vue?vue&type=script&lang=ts&"
export * from "./Police.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports